// App.js
import "./App.css";
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ContactForm from "./components/ContactForm";
import Subscribe from "./pages/Subscribe";
import ScrollToTop from "./components/ScrollToTop";
import Work from "./pages/Work";
import Imprint from "./pages/Imprint";
import CreativeDetails from "./components/CreativeDetails";
import PostProductionDetails from "./components/PostProductionDetails";
import NotFound from "./pages/NotFound"; // ⬅️ Add this import
import TermsConditions from "./pages/TermsConditions";
import Credits from "./pages/Credits";

function AppContent() {
  const { pathname } = useLocation();
  // The /credits landing ships its own nav + footer, so hide the site chrome there
  const hideSiteChrome = pathname === "/credits";

  return (
    <>
      <ScrollToTop />
      {!hideSiteChrome && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/work" element={<Work />} />
        <Route path="/project/:id" element={<CreativeDetails />} />
        <Route
          path="/post-production/:id"
          element={<PostProductionDetails />}
        />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/imprint" element={<Imprint />} />
        <Route path="/credits" element={<Credits />} />
        <Route path="*" element={<NotFound />} /> {/* ⬅️ 404 route added */}
      </Routes>

      {!hideSiteChrome && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
